import { render, staticRenderFns } from "./goodsCard.vue?vue&type=template&id=c98256d6&scoped=true&"
import script from "./goodsCard.vue?vue&type=script&lang=js&"
export * from "./goodsCard.vue?vue&type=script&lang=js&"
import style0 from "./goodsCard.vue?vue&type=style&index=0&id=c98256d6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c98256d6",
  null
  
)

export default component.exports